import { BUSCAR_MAPA_VEICULO_ITINERARIO, SELECIONAR_MAPA_VEICULO_ITINERARIO } from '../../actions/types'

const initialState = undefined

export default function reducerMapaVeiculoItinerario (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_MAPA_VEICULO_ITINERARIO: {
      return action.payload.data;
    }
    case SELECIONAR_MAPA_VEICULO_ITINERARIO: {
      const { assento, fileira } = action.payload;
      const indiceFileira = state.indexOf(state.filter(f => f.id === fileira.id)[0]);
      const novo = [...state];
      const novaFileira = Object.assign({}, fileira);
      const novosAssentos = [...novaFileira.assentos]
      const indiceAssento = novaFileira.assentos.indexOf(assento);
      const novoAssento = Object.assign({}, assento, { selecionado: !assento.selecionado });
      novosAssentos[indiceAssento] = novoAssento;
      novaFileira.assentos = novosAssentos;
      novo[indiceFileira] = novaFileira;
      return novo

    }

    default: {
      return state
    }
  }
}
